import { FieldTemplate, LayoutItem } from 'api/models';
import { RecoilState, atom } from 'recoil';

interface IClipboardState {
  layoutItem: LayoutItem;
  fieldTemplates?: FieldTemplate[];
  alias?: string;
}

export const clipboardAtom: RecoilState<IClipboardState | undefined | null> =
  atom<IClipboardState | undefined | null>({
    key: 'clipboardState',
    default: undefined,
  });
